import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { renderSettingsResourceLabel } from "../../../../../utils/helpers/settings";

export const usePBJCodeColumn = () => {
    const { t } = useTranslation();

    return useMemo(() => {
        return {
            Header: t("PBJ-code"),
            accessor: "pbjCode",
            alwaysVisible: false,
            disableFilters: false,
            Cell: ({ row }) => {
                return renderSettingsResourceLabel(row.original.pbjCode);
            }
        }
    }, [t])
}